module.exports = __webpack_public_path__ + "img/nav2_1.94f62419.jpg";